var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.1 263",
    style: {
      enableBackground: "new 0 0 171.1 263"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0{fill:url(#SVGID_1_);}\n        .st1{fill:#807DFB;}\n        .st2{fill:#423EAF;}\n        .st3{fill:url(#SVGID_00000042702392964545257170000014920304251470996411_);}\n        .st4{fill:#6B67E9;}\n        .st5{fill:#362E94;}\n        .st6{fill:#5652CC;}\n        .st7{fill:#101416;}\n        .st8{fill:url(#SVGID_00000057844113354449512760000006923103472919734710_);}\n        .st9{fill:#20196F;}\n        .st10{fill:#F6F6FB;}\n        .st11{fill:#BBC0E6;}\n        .st12{fill:url(#SVGID_00000116955564697745223510000002304882240331413933_);}\n        .st13{fill:url(#SVGID_00000033326890859952859350000017485735991542189720_);}\n        .st14{fill:url(#SVGID_00000111910848759167495990000002230215420474212753_);}\n        .st15{fill:#A9A9FF;}\n        .st16{fill:#FFAF6D;}\n        .st17{fill:#131147;}\n        .st18{fill:url(#SVGID_00000169534412982349495150000003794923311434154624_);}\n        .st19{fill:url(#SVGID_00000170269484088439116270000017740388802348005267_);}\n        .st20{fill:url(#SVGID_00000005235796987491949460000001543500836465803699_);}\n        .st21{fill:url(#SVGID_00000170277399185905094150000013953146049476425645_);}\n        .st22{fill:url(#SVGID_00000048492799489318968390000007809428179696262588_);}\n        .st23{fill:url(#SVGID_00000019669663050326040780000016956844778700229562_);}\n        .st24{fill:url(#SVGID_00000134209237409059933840000015907741677635526808_);}\n        .st25{fill:url(#SVGID_00000114043699277765242920000004037581411864810941_);}\n        .st26{fill:url(#SVGID_00000002382356224956777010000013492215941409774471_);}\n        .st27{fill:url(#SVGID_00000024681486072317886740000012100568253696299443_);}\n        .st28{fill:#D1D7F3;}\n        .st29{fill:url(#SVGID_00000173157448719952830330000004675597460207181707_);}\n        .st30{fill:#EFEFF3;}\n        .st31{fill:#FF826A;}\n        .st32{fill:#CED3F8;}\n        .st33{fill:url(#SVGID_00000015316078119398977790000007731704073884176005_);}\n        .st34{fill:url(#SVGID_00000006688492431526055660000008651250593855718576_);}\n        .st35{fill:url(#SVGID_00000179647666114694898810000009804930278002340494_);}\n        .st36{fill:#E8ECF7;}\n        .st37{fill:#878787;}\n    ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.7295,
    y1: -837.4698,
    x2: 974.5348,
    y2: -837.4698,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    style: {
      stopColor: "#C2C7E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    style: {
      stopColor: "#C7CCE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    style: {
      stopColor: "#D5D9EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    style: {
      stopColor: "#EDEFF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166,193.6l-34.3-19.8c-6.8-3.9-17.9-3.9-24.7,0L16.5,226c-6.8,3.9-6.8,10.3,0,14.3l34.3,19.8   c0.5,0.3,1.1,0.6,1.6,0.8v2.1h11.1v0c4.4-0.1,8.7-1,12-2.9l90.5-52.3C172.8,203.9,172.8,197.5,166,193.6L166,193.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.3,167.2c-6.8-3.9-17.9-3.9-24.7,0L6.1,219.4c-6.8,3.9-6.8,10.3,0,14.3l34.3,19.8c6.8,3.9,17.9,3.9,24.7,0   l90.5-52.3c6.8-3.9,6.8-10.3,0-14.3L121.3,167.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.7,193.9c0,0.1,0,0.1,0,0.2L160.7,193.9L160.7,193.9z M155.6,201.3l-90.5,52.3c-6.8,3.9-17.9,3.9-24.7,0   L6.1,233.7c-3.2-1.9-4.9-4.3-5.1-6.8v5.8c-0.2,2.7,1.5,5.5,5.1,7.5l34.3,19.8c6.8,3.9,17.9,3.9,24.7,0l90.5-52.3   c3.5-2,5.1-4.6,5.1-7.3l0,0v-6.4C160.7,196.8,159,199.3,155.6,201.3L155.6,201.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123433602636360227740000014746285522846556334_",
    gradientUnits: "userSpaceOnUse",
    x1: 763.4754,
    y1: -789.6057,
    x2: 942.6748,
    y2: -789.6057,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    style: {
      stopColor: "#C2C7E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123433602636360227740000014746285522846556334_)"
    },
    d: "M155.6,187l-20.2-11.7l-33.2,51.9h8.5   l45-26C162.4,197.4,162.4,190.9,155.6,187L155.6,187z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.2,227.2l11.9-26.6l-26.6-15.4l-11.9,26.6L78.2,227.2L78.2,227.2z M63.6,185.2l-11.9,26.6l0-13.8   L63.6,185.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,200.7l-46,26.6l-11.9-26.6l46-26.6L148.2,200.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M148.2,200.7v-13.8L136.2,174L148.2,200.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M102.1,227.2H78.2l11.9-26.6L102.1,227.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M63.6,174.3l26.6,15.4l0,10.9l-26.6-15.4L63.6,174.3L63.6,174.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.2,209.3v7l46-26.6l0,10.9l46-26.6l0-17.8L44.2,209.3L44.2,209.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M126.6,170.6c0.1-1.3,0.8-2.5,1.8-3.2c1-0.6,1.8-0.1,1.8,1.1c-0.1,1.3-0.8,2.5-1.8,3.2   C127.5,172.3,126.6,171.8,126.6,170.6L126.6,170.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M136.2,156.2l-92,53.1l-26.6-15.4l92-53.1L136.2,156.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M17.5,193.9l26.6,15.4v7l-26.6-15.4V193.9L17.5,193.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.6,186.9c0-4.9,3.2-9.7,9.6-13.4c6.4-3.7,14.8-5.6,23.2-5.6c8.4,0,16.8,1.9,23.2,5.6   c6.4,3.7,9.6,8.6,9.6,13.4c0,4.9-3.2,9.7-9.6,13.4c-6.4,3.7-14.8,5.6-23.2,5.6c-8.4,0-16.8-1.9-23.2-5.6   C16.8,196.6,13.6,191.8,13.6,186.9L13.6,186.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052797406295777608130000007255407250174425511_",
    gradientUnits: "userSpaceOnUse",
    x1: 492.5134,
    y1: -783.4227,
    x2: 693.6854,
    y2: -783.4227,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B67E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#423EAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052797406295777608130000007255407250174425511_)"
    },
    d: "M69.7,200.3c-6.4,3.7-14.8,5.6-23.2,5.6   c-8.4,0-16.8-1.9-23.2-5.6c-6.4-3.7-9.6-8.6-9.6-13.4v5.7c0,4.9,3.2,9.7,9.6,13.4c6.4,3.7,14.8,5.6,23.2,5.6   c8.4,0,16.8-1.9,23.2-5.6c6.4-3.7,9.6-8.6,9.6-13.4v-5.7C79.3,191.8,76.1,196.6,69.7,200.3L69.7,200.3z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.9,54.2l-2.8-1.6l0,0c-10.8-6.3-25.7-5.5-42.2,4.1l0,16.1c1-0.6,2-1.1,3-1.6l0-12.7   C107.3,48.9,122.2,48,132.9,54.2L132.9,54.2z M121.6,70.5c7.4,5.1,11.8,14.9,11.8,28.5c0,17-7,36.2-17.9,52l3,1.7   c10.9-15.9,17.9-35,17.9-52C136.4,85.3,130.7,74.8,121.6,70.5L121.6,70.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.4,100.7c0,17-7,36.2-17.9,52l5.8-3.4l7.2,4.1c11.6-19.2,18.8-41.1,18.8-60.9c0-37.9-26.6-53.2-59.4-34.3   l0,16.1C116.1,60,136.4,71.7,136.4,100.7L136.4,100.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M77.7,60.2L75,58.7l11.8-6.8l2.7,1.6l2.7,1.6l-11.8,6.8L77.7,60.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M92.2,79.1l-11.8,6.8l0-24.1L92.2,55L92.2,79.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M89.4,69.3c0-3.1,2.2-6.9,4.9-8.5c2.7-1.6,4.9-0.3,4.9,2.8c0,3.1-2.2,6.9-4.9,8.5   C91.5,73.7,89.4,72.5,89.4,69.3L89.4,69.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147922220332390211120000006744692450276214156_",
    gradientUnits: "userSpaceOnUse",
    x1: 721.1284,
    y1: -391.2454,
    x2: 742.285,
    y2: -354.6022,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6F6FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147922220332390211120000006744692450276214156_)"
    },
    d: "M89.4,69.3c0-3.1,2.2-6.9,4.9-8.5   c1.3-0.7,2.5-0.8,3.3-0.4l-1.2-0.7c-0.9-0.6-2.2-0.6-3.6,0.3c-2.7,1.6-4.9,5.4-4.9,8.5c0,1.5,0.5,2.6,1.4,3.1h0c0,0,0.1,0,0.1,0.1   l1.3,0.8C89.9,72,89.4,70.9,89.4,69.3L89.4,69.3z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92.9,67.3c0.1-1,0.6-1.9,1.4-2.4c0.8-0.4,1.4-0.1,1.4,0.8c-0.1,1-0.6,1.9-1.4,2.4   C93.5,68.5,92.9,68.2,92.9,67.3L92.9,67.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012433322883856483750000015084179250291118464_",
    gradientUnits: "userSpaceOnUse",
    x1: 560.9464,
    y1: -622.6221,
    x2: 632.3314,
    y2: -622.6221,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9A9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012433322883856483750000015084179250291118464_)"
    },
    d: "M55.9,135.3c-2.3,1.3-5.3,2-8.2,2   c-3,0-6-0.7-8.2-2c-2.3-1.3-3.4-3-3.4-4.8v25.5c0,1.7,1.1,3.4,3.4,4.8c2.3,1.3,5.3,2,8.2,2c3,0,6-0.7,8.2-2c2.3-1.3,3.4-3,3.4-4.8   v-25.5C59.3,132.3,58.1,134,55.9,135.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034083074428452300030000008140039239300406681_",
    gradientUnits: "userSpaceOnUse",
    x1: 561.1544,
    y1: -666.6302,
    x2: 632.2803,
    y2: -666.6302,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E33C5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034083074428452300030000008140039239300406681_)"
    },
    d: "M55.9,160.9c-2.3,1.3-5.3,2-8.2,2   c-3,0-6-0.7-8.2-2c-2-1.1-3.1-2.6-3.3-4c0.4,2.6,2.8,6.2,4.6,7.2c1.9,1.1,4.5,1.7,7,1.7c2.5,0,5.1-0.6,7-1.7   c1.9-1.1,4.5-4.2,4.6-7.6C59.1,158.1,58,159.6,55.9,160.9L55.9,160.9z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M43.8,150.2c-0.6-1.2-1.5-2.4-2.5-3.3c-1.1-1.1-2.3-2.1-3.6-2.9c-1.2-0.7-2.1-0.9-2.6-0.7   c-0.1,0-0.2,0.1-0.2,0.2L23.1,156c0.1-0.1,0.1-0.1,0.2-0.2c0.5-0.2,1.4,0,2.6,0.7c1.3,0.8,2.5,1.8,3.6,2.9c1,1,1.8,2.1,2.5,3.3   c0.4,0.8,0.4,1.4,0.1,1.7L44,151.9C44.2,151.6,44.2,151,43.8,150.2L43.8,150.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M25.9,156.6c1.3,0.8,2.5,1.8,3.6,2.9c1,1,1.8,2.1,2.5,3.3c0.5,1,0.4,1.6-0.1,1.8c-0.5,0.2-1.4,0-2.6-0.7   c-1.3-0.8-2.5-1.8-3.6-2.9c-1-1-1.8-2.1-2.5-3.3c-0.5-1-0.4-1.6,0.1-1.9C23.8,155.7,24.7,155.9,25.9,156.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M26.7,158.3c0.7,0.4,1.3,0.9,1.9,1.5c0.5,0.5,1,1.1,1.3,1.8c0.2,0.5,0.2,0.9-0.1,1c-0.3,0.1-0.7,0-1.4-0.4   c-0.7-0.4-1.3-0.9-1.9-1.5c-0.5-0.5-1-1.1-1.3-1.8c-0.2-0.5-0.2-0.9,0.1-1C25.6,157.9,26,158,26.7,158.3L26.7,158.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070077167043680346640000002608663391819857563_",
    gradientUnits: "userSpaceOnUse",
    x1: 521.4894,
    y1: -660.3729,
    x2: 556.2219,
    y2: -660.3729,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E33C5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070077167043680346640000002608663391819857563_)"
    },
    d: "M34.1,160.6c-0.6-1.2-1.5-2.4-2.5-3.3   c-1.1-1.1-2.3-2.1-3.6-2.9c-1.2-0.7-2.1-0.9-2.6-0.7c-0.1,0-0.2,0.1-0.2,0.2l-2.1,2.3c0.1-0.1,0.1-0.1,0.2-0.2   c0.5-0.2,1.4,0,2.6,0.7c1.3,0.8,2.5,1.8,3.6,2.9c1,1,1.8,2.1,2.5,3.3c0.4,0.8,0.4,1.4,0.1,1.7l2.1-2.3h0   C34.5,162,34.5,161.4,34.1,160.6L34.1,160.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063595415472226694170000010557310877707458466_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.9554,
    y1: -551.2282,
    x2: 714.3144,
    y2: -551.2282,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9A9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063595415472226694170000010557310877707458466_)"
    },
    d: "M9.2,116.2v24c0,4.3,2.9,8.7,8.6,12   c5.7,3.3,13.3,5,20.8,5c7.5,0,15.1-1.7,20.8-5l18.1-10.4c5.7-3.3,8.6-7.7,8.6-12V89.5L9.2,116.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169545158632896867090000008609977304145770174_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.9554,
    y1: -604.8932,
    x2: 714.3144,
    y2: -604.8932,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E33C5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169545158632896867090000008609977304145770174_)"
    },
    d: "M77.5,136.6L59.4,147   c-5.7,3.3-13.3,5-20.8,5c-7.5,0-15.1-1.7-20.8-5c-5.7-3.3-8.6-7.7-8.6-12v5.2c0,4.3,2.9,8.7,8.6,12c5.7,3.3,13.3,5,20.8,5   c7.5,0,15.1-1.7,20.8-5l18.1-10.4c5.7-3.3,8.6-7.7,8.6-12v-5.2C86.1,128.9,83.2,133.3,77.5,136.6L77.5,136.6z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M27.2,47.6c0-4.4,2.9-8.7,8.6-12c5.7-3.3,13.3-5,20.8-5c7.5,0,15.1,1.7,20.8,5c5.7,3.3,8.6,7.7,8.6,12   c0,4.4-2.9,8.7-8.6,12c-5.7,3.3-13.3,5-20.8,5c-7.5,0-15.1-1.7-20.8-5C30.1,56.3,27.2,52,27.2,47.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060747289660539968540000000611783160182209977_",
    gradientUnits: "userSpaceOnUse",
    x1: 534.2004,
    y1: -409.6377,
    x2: 714.3164,
    y2: -409.6377,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9A9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060747289660539968540000000611783160182209977_)"
    },
    d: "M77.5,59.6c-5.7,3.3-13.3,5-20.8,5   c-7.5,0-15.1-1.7-20.8-5c-5.7-3.3-8.6-7.7-8.6-12v0h0v41.9c0,4.3,2.9,8.7,8.6,12c5.7,3.3,13.3,5,20.8,5c7.5,0,15.1-1.7,20.8-5   c5.7-3.3,8.6-7.7,8.6-12h0V47.6C86.1,52,83.2,56.3,77.5,59.6L77.5,59.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008862764435375647860000007157055778127292090_",
    gradientUnits: "userSpaceOnUse",
    x1: 534.2004,
    y1: -353.8497,
    x2: 714.3164,
    y2: -353.8497,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E33C5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008862764435375647860000007157055778127292090_)"
    },
    d: "M77.5,59.6c-5.7,3.3-13.3,5-20.8,5   c-7.5,0-15.1-1.7-20.8-5c-5.7-3.3-8.6-7.7-8.6-12v0h0v5.5h0v0c0,4.3,2.9,8.7,8.6,12c5.7,3.3,13.3,5,20.8,5c7.5,0,15.1-1.7,20.8-5   c5.7-3.3,8.6-7.7,8.6-12v-5.5C86.1,52,83.2,56.3,77.5,59.6L77.5,59.6z"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M56.6,106.5c-7.5,0-15.1-1.7-20.8-5c-5.7-3.3-8.6-7.7-8.6-12v-3c0,0-6.8,8.7-12.8,16.7   c-9.5,12.6-4.6,22,3.4,26.6c8,4.6,27.1,5.5,38.2-6l21.5-22.2l-0.1,0C71.7,104.8,64.2,106.5,56.6,106.5L56.6,106.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071518794956066998540000003877820219572478088_",
    gradientUnits: "userSpaceOnUse",
    x1: 624.2603,
    y1: -319.4987,
    x2: 714.3163,
    y2: -319.4987,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    style: {
      stopColor: "#C2C7E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071518794956066998540000003877820219572478088_)"
    },
    d: "M56.6,55.9h25.7c2.5-2.6,3.7-5.4,3.7-8.2   c0-2.8-1.2-5.7-3.7-8.2H56.6L56.6,55.9z"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M42.4,8.7c0-2.1,1.4-4.2,4.2-5.8c2.8-1.6,6.4-2.4,10.1-2.4c3.7,0,7.3,0.8,10.1,2.4s4.2,3.7,4.2,5.8   c0,2.1-1.4,4.2-4.2,5.8c-2.8,1.6-6.4,2.4-10.1,2.4c-3.7,0-7.3-0.8-10.1-2.4C43.8,12.9,42.4,10.8,42.4,8.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148634582265894205560000017300916285141661361_",
    gradientUnits: "userSpaceOnUse",
    x1: 594.2054,
    y1: -193.5351,
    x2: 654.3204,
    y2: -193.5351,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B73251"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF826A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148634582265894205560000017300916285141661361_)"
    },
    d: "M49.7,7.2c1.9-1.1,4.4-1.7,6.9-1.7   c2.5,0,5,0.6,6.9,1.7c1.4,0.8,2.2,1.7,2.6,2.7c0.2-0.4,0.2-0.8,0.3-1.3c0-1.5-1-2.9-2.9-4C61.7,3.5,59.2,3,56.6,3   c-2.5,0-5,0.6-6.9,1.7c-1.9,1.1-2.9,2.6-2.9,4c0,0.4,0.1,0.9,0.3,1.3C47.5,8.9,48.3,8,49.7,7.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009575251793294990100000008975586989975988615_",
    gradientUnits: "userSpaceOnUse",
    x1: 594.9734,
    y1: -204.1557,
    x2: 653.5504,
    y2: -204.1557,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#131147"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    style: {
      stopColor: "#16134D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    style: {
      stopColor: "#1D1A5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    style: {
      stopColor: "#292677"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    style: {
      stopColor: "#39369C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#423EAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009575251793294990100000008975586989975988615_)"
    },
    d: "M49.7,12.7c1.9,1.1,4.4,1.7,6.9,1.7   c2.5,0,5-0.6,6.9-1.7c1.4-0.8,2.2-1.7,2.6-2.7c-0.4-1-1.3-2-2.6-2.7c-1.9-1.1-4.4-1.7-6.9-1.7c-2.5,0-5,0.6-6.9,1.7   c-1.4,0.8-2.2,1.7-2.6,2.7C47.5,10.9,48.3,11.9,49.7,12.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176758566127435549710000001137472859693948846_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.6114,
    y1: -272.4857,
    x2: 667.9124,
    y2: -272.4857,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CED3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9A9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176758566127435549710000001137472859693948846_)"
    },
    d: "M66.7,14.5c-2.8,1.6-6.4,2.4-10.1,2.4   c-3.7,0-7.3-0.8-10.1-2.4c-2.8-1.6-4.2-3.7-4.2-5.8v39c0,2.1,1.4,4.2,4.2,5.8c2.8,1.6,6.4,2.4,10.1,2.4c3.7,0,7.3-0.8,10.1-2.4   c2.8-1.6,4.2-3.7,4.2-5.8v-39C70.9,10.8,69.5,12.9,66.7,14.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111903121451220523900000015653966545818696335_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.6114,
    y1: -219.8042,
    x2: 667.9124,
    y2: -219.8042,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF826A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E33C5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111903121451220523900000015653966545818696335_)"
    },
    d: "M66.7,14.5c-2.8,1.6-6.4,2.4-10.1,2.4   c-3.7,0-7.3-0.8-10.1-2.4c-2.8-1.6-4.2-3.7-4.2-5.8v4.5c0,2.1,1.4,4.2,4.2,5.8c2.8,1.6,6.4,2.4,10.1,2.4c3.7,0,7.3-0.8,10.1-2.4   c2.8-1.6,4.2-3.7,4.2-5.8V8.7C70.9,10.8,69.5,12.9,66.7,14.5z"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M60,9.3c0.7-0.3,1.5-0.3,2.1,0c0.6,0.3,0.6,0.9,0,1.2c-0.7,0.3-1.5,0.3-2.1,0C59.4,10.2,59.4,9.7,60,9.3z    M56.9,10.9c0.4-0.2,0.9-0.2,1.3,0c0.2,0.1,0.3,0.3,0.2,0.5c0,0.1-0.1,0.2-0.2,0.2c-0.4,0.2-0.9,0.2-1.3,0   c-0.2-0.1-0.3-0.3-0.2-0.5C56.7,11.1,56.8,11,56.9,10.9L56.9,10.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.8,133.4L64,140.8v-8.6l12.8-7.4V133.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.4,132c0.1-1.1,0.6-2.1,1.6-2.7c0.9-0.5,1.6-0.1,1.6,0.9c-0.1,1.1-0.6,2.1-1.6,2.7   C73.1,133.5,72.4,133,72.4,132L72.4,132z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M118.6,152.7l8.1-2.1l-2.3-1.3L118.6,152.7L118.6,152.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090277849149837431160000010086228101529282993_",
    gradientUnits: "userSpaceOnUse",
    x1: 543.3348,
    y1: -744.9252,
    x2: 694.0663,
    y2: -744.9252,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090277849149837431160000010086228101529282993_)"
    },
    d: "M72.2,176.6c-4.9-2.8-11.4-4.2-17.8-4.2v0   H44.2v1.4c-2.4,0.6-4.6,1.6-6.8,2.8c-9.6,5.6-9.6,14.6,0,20.1c2.1,1.2,4.4,2.1,6.8,2.8v1.4h10.3v0c6.4,0.1,12.9-1.3,17.8-4.2   C81.9,191.2,81.9,182.2,72.2,176.6L72.2,176.6z"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M61.2,196c-8.9,5.2-23.4,5.2-32.4,0s-8.9-13.5,0-18.7c8.9-5.2,23.4-5.2,32.4,0   C70.2,182.5,70.2,190.9,61.2,196L61.2,196z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M47.9,179.6c-1.1,2-1.2,3.4-0.3,4.4c1,1,2.5,1,4.8,0.2c2.2-0.8,3.3-0.6,3.6-0.3c0.3,0.3,0.5,1.3-0.7,3.2   c-0.1,0.2,0,0.5,0.3,0.7c0.3,0.2,0.5,0.2,0.6,0.1c1.1-2,1.2-3.4,0.3-4.4c-1-1-2.5-1-4.8-0.2c-2.2,0.8-3.3,0.6-3.6,0.3   c-0.3-0.3-0.5-1.3,0.7-3.2c0.1-0.2,0-0.5-0.3-0.7C48.2,179.5,48,179.5,47.9,179.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M42.3,177c0.7-0.4,1.9-0.3,2.6,0.1c0.7,0.4,0.8,1,0.1,1.4c-0.8,0.4-1.8,0.4-2.6,0   C41.6,178.1,41.6,177.4,42.3,177L42.3,177z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M37.1,192c1-0.6,2.6-0.4,3.6,0.1c1,0.6,1.1,1.5,0.1,2c-1.1,0.6-2.5,0.6-3.7,0C36.2,193.6,36.1,192.6,37.1,192   L37.1,192z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.8,181.7c1.7-1,4.6-1,6.3,0c1.7,1,1.7,2.6,0,3.6c-1.7,1-4.6,1-6.3,0C31.1,184.3,31.1,182.7,32.8,181.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.9,186.4c-0.2-0.1-0.5-0.3-0.8-0.3c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.3-0.2-0.5-0.3   c-0.1-0.1-0.2-0.2-0.3-0.2c0.3-0.2,0.6-0.5,0.8-0.9c0.2,0,0.3,0,0.4,0.1c0.2,0,0.4,0,0.8,0.1c0.4,0.1,0.6,0.1,0.7,0.1   c0.2,0,0.4,0.1,0.8,0.2c0.2,0,0.4,0,0.5-0.2c0.1-0.1-0.1-0.2-0.3-0.3c-0.4-0.1-0.5-0.1-0.7-0.1c-0.2,0-0.4-0.1-0.8-0.2   c-0.4-0.1-0.6-0.1-0.8-0.1c-0.1,0-0.3,0-0.4-0.1c0.1-0.3,0.1-0.5,0-0.8c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.2,0.5-0.2   c0.4-0.1,0.6-0.1,0.8-0.1c0.2,0,0.4,0,0.8-0.1c0.2,0,0.3-0.2,0.3-0.3c-0.1-0.1-0.3-0.2-0.5-0.2c-0.4,0.1-0.6,0.1-0.8,0.1   c-0.2,0-0.4,0-0.8,0.1c-0.3,0-0.6,0.1-0.9,0.3c-0.1,0-0.1,0.1-0.2,0.1c-0.2-0.4-0.5-0.7-0.9-1c0.1,0,0.2-0.1,0.3-0.1   c0.3-0.1,0.5-0.2,0.8-0.3c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.1,0.2-0.3,0.3-0.3c0.1,0,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.1-0.1   c-0.2-0.1-0.4-0.1-0.6,0c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.1-0.2,0.3-0.3,0.3c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.3,0.1-0.5,0.2   c-0.5-0.3-1.1-0.4-1.7-0.5c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.4-0.3,0.6-0.5c0.1-0.2,0.1-0.4,0.1-0.5c0-0.1,0-0.3,0.1-0.4   c0.1-0.1-0.1-0.2-0.3-0.3c-0.2,0-0.4,0-0.5,0.2c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.3-0.3,0.3   c-0.2,0.1-0.3,0.2-0.4,0.3c-0.2,0-0.4,0-0.7,0c-0.2,0-0.5,0-0.7,0c0-0.1-0.1-0.2-0.1-0.2c0-0.2-0.1-0.3-0.2-0.5   c-0.1-0.2-0.3-0.4-0.6-0.5c-0.1-0.1-0.3-0.2-0.3-0.3c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.3,0.2-0.3,0.3c0.1,0.2,0.3,0.4,0.6,0.5   c0.1,0.1,0.3,0.2,0.3,0.3c0.1,0.1,0.1,0.3,0.2,0.4c0,0.1,0.1,0.2,0.1,0.3c-0.6,0.1-1.1,0.3-1.7,0.5l-0.3-0.2l-0.6-0.3   c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2-0.1-0.4-0.1-0.6,0c-0.1,0-0.1,0.1-0.1,0.2c0,0,0.1,0.1,0.1,0.1   c0.2,0.1,0.3,0.2,0.5,0.3c0.2,0.2,0.4,0.3,0.6,0.4l0.6,0.3l0.3,0.2c-0.3,0.2-0.6,0.5-0.8,0.7c-0.2,0-0.3,0-0.5-0.1   c-0.2,0-0.4,0-0.8-0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.2,0-0.5,0-0.7-0.1c-0.2,0-0.4,0-0.5,0.2c-0.1,0.1,0.1,0.2,0.3,0.3   c0.3,0,0.6,0.1,0.9,0.1c0.2,0,0.5,0,0.7,0.1c0.4,0.1,0.6,0.1,0.8,0.1c0.1,0,0.2,0,0.4,0c-0.1,0.2-0.1,0.4-0.1,0.6   c0,0.1,0,0.3,0,0.4c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0.1-0.3,0.1-0.4,0.2l-0.4,0.1c-0.2,0-0.3,0-0.5,0c-0.3,0-0.7,0-1,0   c-0.2,0-0.3,0.2-0.3,0.3c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4,0,0.7,0c0.3,0,0.7,0,1,0c0.3,0,0.6-0.1,0.9-0.3c0.1,0,0.1-0.1,0.2-0.1   c0.2,0.4,0.6,0.8,1,1c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.1-0.5,0.2-0.7,0.3c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.5,0.2-0.7,0.3   c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.1,0.1,0.1c0.2,0.1,0.4,0.1,0.6,0c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.5-0.2,0.7-0.3   c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.1,0.4-0.2c0.4,0.2,0.8,0.3,1.2,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3-0.1,0.4   c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.1,0.1,0.2,0.3,0.3c0.2,0,0.4,0,0.5-0.2c0.1-0.2,0.1-0.3,0.2-0.5   c0.1-0.2,0.1-0.3,0.2-0.4c0.1-0.2,0.1-0.4,0.1-0.5c0-0.1,0-0.1,0-0.2c0.7,0.1,1.4,0.1,2.2,0c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0.1,0.6   c0.1,0.1,0.1,0.3,0.1,0.4c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.2,0.3-0.3c-0.1-0.1-0.1-0.3-0.1-0.4   c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2,0-0.4c0.5-0.1,0.9-0.3,1.4-0.5c0.1,0.1,0.2,0.1,0.2,0.2   c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.1,0.5,0.3,0.8,0.3c0.2,0,0.4,0.1,0.6,0.2c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.1-0.1,0.1-0.2   C42,186.4,42,186.4,41.9,186.4L41.9,186.4z M33.1,185.2c-0.8-0.4-1.2-1-1.2-1.7s0.4-1.2,1.2-1.7c1.8-0.9,3.9-0.9,5.8,0   c1.6,0.9,1.6,2.4,0,3.3C37.3,186.1,34.7,186.1,33.1,185.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.6,184c0.5-0.2,1-0.2,1.5,0c0.2,0.1,0.4,0.3,0.3,0.6c0,0.1-0.1,0.2-0.3,0.3c-0.5,0.2-1,0.2-1.5,0   c-0.2-0.1-0.4-0.3-0.3-0.6C35.4,184.2,35.5,184.1,35.6,184L35.6,184z M34.7,182.9c0.2-0.1,0.4-0.1,0.5,0c0.1,0,0.1,0.1,0.1,0.2   c0,0-0.1,0.1-0.1,0.1c-0.2,0.1-0.4,0.1-0.5,0c-0.1,0-0.1-0.1-0.1-0.2C34.6,182.9,34.7,182.9,34.7,182.9z M36.7,182.5   c0.3-0.2,0.7-0.2,1.1,0c0.2,0.1,0.3,0.2,0.2,0.4c0,0.1-0.1,0.2-0.2,0.2c-0.3,0.2-0.7,0.2-1.1,0c-0.2-0.1-0.3-0.2-0.2-0.4   C36.6,182.6,36.7,182.5,36.7,182.5L36.7,182.5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.7,189.9l3.7-1.3c0.5-0.2,0.7-0.6,0.4-0.9c-0.5-0.3-1.1-0.4-1.6-0.2l-3.7,1.3c-0.5,0.2-0.7,0.6-0.4,0.9   C44.5,190,45.1,190.1,45.7,189.9L45.7,189.9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M64.6,187.6l-1.8-2.1c-0.3-0.3-0.9-0.4-1.5-0.3c-0.5,0.2-0.8,0.5-0.5,0.8l1.8,2.1c0.3,0.3,0.9,0.4,1.5,0.3   C64.7,188.3,64.9,187.9,64.6,187.6L64.6,187.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M55.3,181.1l2.4,0.1c0.5-0.1,0.9-0.3,1.1-0.8c0.2-0.4,0.1-0.8-0.2-0.8l-2.4-0.1c-0.5,0.1-0.9,0.3-1.1,0.8   C54.8,180.7,54.9,181.1,55.3,181.1L55.3,181.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096018751978207912970000009488007338875829890_",
    gradientUnits: "userSpaceOnUse",
    x1: 518.7047,
    y1: -744.9251,
    x2: 601.5564,
    y2: -744.9251,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096018751978207912970000009488007338875829890_)"
    },
    d: "M37.2,196c-8.9-5.2-8.9-13.5,0-18.7   c3.4-2,7.6-3.2,12-3.6c-7.2-0.8-14.8,0.4-20.4,3.6c-8.9,5.2-8.9,13.5,0,18.7c5.5,3.2,13.2,4.4,20.4,3.6   C44.8,199.2,40.6,198,37.2,196L37.2,196z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076597623278704831340000009855202777206743980_",
    gradientUnits: "userSpaceOnUse",
    x1: 518.7049,
    y1: -710.2646,
    x2: 658.7512,
    y2: -710.2646,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -147.3913 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBC0E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    style: {
      stopColor: "#CED2ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8ECF7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076597623278704831340000009855202777206743980_)"
    },
    d: "M28.8,171c8.9-5.2,23.4-5.2,32.4,0   c5.9,3.4,7.9,8.2,6,12.5c-1-2.3-3-4.4-6-6.2c-8.9-5.2-23.4-5.2-32.4,0c-3.1,1.8-5.1,3.9-6,6.2C21,179.2,23,174.4,28.8,171L28.8,171   z"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M62.5,170.3c-9.6-5.6-25.2-5.6-34.8,0c-9.6,5.6-9.6,14.6,0,20.1c9.6,5.6,25.2,5.6,34.8,0   C72.1,184.9,72.1,175.9,62.5,170.3L62.5,170.3z M61.2,189.7c-8.9,5.2-23.4,5.2-32.4,0c-8.9-5.2-8.9-13.5,0-18.7   c8.9-5.2,23.4-5.2,32.4,0C70.2,176.2,70.2,184.6,61.2,189.7L61.2,189.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131363634692467052330000005943271191037114552_",
    gradientUnits: "userSpaceOnUse",
    x1: 513.3614,
    y1: -757.6074,
    x2: 664.0934,
    y2: -757.6074,
    gradientTransform: "matrix(0.3268 0 0 -0.3268 -205.4099 -56.8006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    style: {
      stopColor: "#CED2ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBC0E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131363634692467052330000005943271191037114552_)"
    },
    d: "M62.5,190.4c-9.6,5.6-25.2,5.6-34.8,0   c-4.6-2.7-7-6.2-7.2-9.7h0v5.7h0c-0.1,3.7,2.3,7.4,7.2,10.3c9.6,5.6,25.2,5.6,34.8,0c4.9-2.8,7.3-6.6,7.2-10.3h0v-5.7h0   C69.5,184.3,67.1,187.8,62.5,190.4L62.5,190.4z"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M62.5,190.4v6.3c1.8-1,3.3-2.3,4.7-3.8v-6.3C65.8,188.2,64.2,189.4,62.5,190.4L62.5,190.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M22.3,192.2c1.3,1.7,2.9,3.1,4.7,4.2v-6.3c-1.8-1.1-3.4-2.5-4.7-4.2V192.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.5da09adadd47c5f7a18296994c0706a3.svg";
export { ForwardRef as ReactComponent };